/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useRef, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import {makeStyles} from "@material-ui/core/styles";
import {
    CREATE_FILTER,
    DELETE_FILTERS,
    GET_FILTER,
    GET_FILTERS_OF_TYPE,
    UPDATE_FILTER
} from "../database/queries/filterQueries"; //optional, for more compact styles
import {BasicConfig, Builder, Query, Utils as QbUtils} from "react-awesome-query-builder";
import 'react-awesome-query-builder/css/styles.scss';
import 'react-awesome-query-builder/css/compact_styles.scss';
import {useMutation, useQuery} from "@apollo/react-hooks";
import Moment from "react-moment";
import CalendarStrings from "../constants/calendarStrings";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../constants/tableIcons";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import {notify} from "../utils/notify";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";

const InitialConfig = BasicConfig;

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    dlog: {
        // zIndex: '1000 !important',
        '& .MuiDialog-paper': {
            width: 600,
        },
        '& .query-builder-container': {
            padding: 0,
        },
        '& .query-builder': {
            margin: 0,
        },
        '& .group': {
            background: '#f4f6f8',
            border: '1px solid #108FC0'
        }
    }
}));

const columns = [
    {
        title: 'Name',
        width: '25%',
        field: 'filterName',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Description',
        width: '30%',
        field: 'filterDescription',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Query',
        width: '30%',
        field: 'filterSQL',
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
    {
        title: 'Last Updated',
        width: '15%',
        render: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
        headerStyle: {padding: 3},
        cellStyle: {padding: 3}
    },
];

const accountFields = {
    "`accounts`.`account_name`": {
        label: 'Name',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`accounts`.`account_description`": {
        label: 'Description',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`tags`.`tag`": {
        label: 'Tag',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`emailAddresses`.`email_address`": {
        label: 'Email',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`address_1`": {
        label: 'Address',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`city`": {
        label: 'City',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`state`": {
        label: 'State',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`postal_code`": {
        label: 'Postal Code',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`phoneNumbers`.`phone_number`": {
        label: 'Phone',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`accounts`.`created_at`": {
        label: 'Created Date',
        type: 'date',
        valueSources: ['value'],
        preferWidgets: ['date'],
    },
    "`accounts`.`updated_at`": {
        label: 'Last Updated Date',
        type: 'date',
        valueSources: ['value'],
        preferWidgets: ['date'],
    },
}

const contactFields = {
    "`contacts`.`contact_first_name`": {
        label: 'First Name',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`contacts`.`contact_last_name`": {
        label: 'Last Name',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`contacts`.`contact_description`": {
        label: 'Description',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`tags`.`tag`": {
        label: 'Tag',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`emailAddresses`.`email_address`": {
        label: 'Email',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`address_1`": {
        label: 'Address',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`city`": {
        label: 'City',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`state`": {
        label: 'State',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`mailAddresses`.`postal_code`": {
        label: 'Postal Code',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`phoneNumbers`.`phone_number`": {
        label: 'Phone',
        type: 'text',
        valueSources: ['value'],
        preferWidgets: ['text'],
    },
    "`contacts`.`created_at`": {
        label: 'Created Date',
        type: 'date',
        valueSources: ['value'],
        preferWidgets: ['date'],
    },
    "`contacts`.`updated_at`": {
        label: 'Last Updated Date',
        type: 'date',
        valueSources: ['value'],
        preferWidgets: ['date'],
    },
}

const FilterDialog = props => {
    const classes = useStyles();
    const [filter, setFilter] = useState({});
    const [filters, setFilters] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [mode, setMode] = useState('list');
    const [errors, setErrors] = useState({});
    const [config, setConfig] = useState();
    const [state, setState] = useState();
    const tableRef = useRef();

    const NEW_FILTER = {
        filterType: props.filterType,
        filterName: 'New Filter',
        filterDescription: null,
        filterJSON: null,
        filterSQL: null
    };

    const {data: getFiltersOfTypeData, refetch: getFiltersOfTypeRefetch} = useQuery(GET_FILTERS_OF_TYPE, {
        skip: !props.open,
        variables: {
            filterType: props.filterType,
            orderList: ['filterName ASC']
        },
    });

    const {data: getFilterData, refetch: getFilterRefetch} = useQuery(GET_FILTER, {
        skip: !(mode === 'edit' && selectedObj.filterId),
        variables: {
            filterId: selectedObj.filterId,
        },
    });

    const [updateFilter] = useMutation(UPDATE_FILTER, {
        variables: {
            changedFilter: {
                filterId: filter.filterId,
                filterType: props.filterType,
                filterName: filter.filterName,
                filterDescription: filter.filterDescription,
                filterJSON: filter.filterJSON,
                filterSQL: filter.filterSQL
            }
        }
    });

    const [createFilter] = useMutation(CREATE_FILTER, {
        variables: {
            newFilter: {
                filterType: props.filterType,
                filterName: filter.filterName,
                filterDescription: filter.filterDescription,
                filterJSON: filter.filterJSON,
                filterSQL: filter.filterSQL
            }
        }
    });

    const [deleteFilters] = useMutation(DELETE_FILTERS);

    const handleQueryChange = (immutableTree, configParam) => {
        // Tip: for better performance you can apply `throttle` - see `examples/demo`
        setState({tree: immutableTree, config: configParam});

        const jsonTree = QbUtils.getTree(immutableTree);
        const jsonSQL = QbUtils.sqlFormat(immutableTree, configParam);
        // `jsonTree` can be saved to backend, and later loaded to `queryValue`

        const updatedFilter = {
            ...filter,
            filterJSON: JSON.stringify(jsonTree),
            filterSQL: jsonSQL
        };
        setFilter(updatedFilter);
    };

    const handleFieldChange = (e) => {
        const updatedFilter = {
            ...filter,
            [e.target.name]: e.target.value
        };
        setFilter(updatedFilter);
    };

    const handleDelete = () => {
        const selectedIds = selectedRows.map(row => row.filterId);
        deleteFilters({
            variables: {deleteFilterIds: selectedIds}
        }).then(deleteFiltersResult => {
            if (deleteFiltersResult.data.deleteFilters.returnCode === 0) {
                notify('deleteFilters', 'info', deleteFiltersResult.data.deleteFilters.message);
            } else {
                notify('deleteFilters', 'error', deleteFiltersResult.data.deleteFilters.message);
            }
            getFiltersOfTypeRefetch();
        }).catch(e => {
            notify('deleteFilters', 'error', e.message);
            getFiltersOfTypeRefetch();
        })
    };

    const renderBuilder = (props) => (
        <div className="query-builder-container">
            <div className="query-builder qb-lite">
                <Builder {...props} />
            </div>
        </div>
    );

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!filter.filterName || filter.filterName.length === 0) newError.filterName = 'Filter Name cannot be empty';
        if (!filter.filterJSON || filter.filterJSON.length === 0) newError.filterJSON = 'Filter query cannot be empty';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    useEffect(() => {
        if (props.open) {
            getFiltersOfTypeRefetch();
        }
    }, [props.open]);

    useEffect(() => {
        if (getFiltersOfTypeData && getFiltersOfTypeData.filtersOfType) {
            setSelectedRows([]);
            setSelectedObj({});
            setFilters(getFiltersOfTypeData.filtersOfType);
            if (getFiltersOfTypeData.filtersOfType.length === 0) {
                setFilter({...NEW_FILTER});
                setMode('edit');
            }
        }
    }, [getFiltersOfTypeData]);

    useEffect(() => {
        if (getFilterData && getFilterData.filter) {
            setFilter(getFilterData.filter);
            setFilter({
                ...NEW_FILTER,
                filterId: getFilterData.filter.filterId,
                filterType: getFilterData.filter.filterType,
                filterName: getFilterData.filter.filterName,
                filterDescription: getFilterData.filter.filterDescription,
                filterJSON: getFilterData.filter.filterJSON,
                filterSQL: getFilterData.filter.filterSQL
            });
            setState({
                tree: QbUtils.checkTree(QbUtils.loadTree(getFilterData.filter.filterJSON), config),
                config: config
            });
            setMode('edit');
        }
    }, [getFilterData]);

    useEffect(() => {
        if (config) {
            const childId = QbUtils.uuid();
            const newQueryObj = {
                id: QbUtils.uuid(),
                type: "group",
                children1: {
                    [childId]: {
                        type: "rule",
                        properties: {
                            field: props.filterType === 'account' ? "accountName" : "contactFirstName",
                            operator: "like",
                            value: props.filterType === 'account' ? ["Acme Unlimited"] : ["Bob"],
                            valueSrc: ["value"],
                            valueType: ["text"]
                        }
                    },
                }
            };

            setState({
                tree: QbUtils.checkTree(QbUtils.loadTree(newQueryObj), config),
                config: config
            });
        }
    }, [config]);

    useEffect(() => {
        setConfig({
            ...InitialConfig,
            fields: props.filterType === 'account' ? accountFields : contactFields
        });
    }, []);

    return (
        <div>
            <Dialog className={classes.dlog} open={props.open} onClose={props.handleCancel}
                    aria-labelledby="form-dialog-title"
                    disableEnforceFocus={true}>
                <div>
                    <AppBar position="static" color={props.color ? props.color : 'default'} className={classes.toolbar}>
                        <Toolbar variant="dense" className={classes.toolbar}>
                            <Typography variant="subtitle1" color="inherit" m={2} style={{marginRight: 20}}>
                                Filters
                            </Typography>
                            {props.showLoading && <CircularProgress color="inherit" size={24}/>}
                            <div className={classes.grow}/>
                            {mode === 'list' && <Tooltip title={"Add"}>
                                <div>
                                    <IconButton
                                        id={"add-button"}
                                        aria-controls="add"
                                        disabled={selectedRows.length > 0}
                                        color="inherit"
                                        aria-label="add"
                                        onClick={() => {
                                            setFilter({...NEW_FILTER});
                                            setMode('edit');
                                        }}
                                    >
                                        <AddIcon/>
                                    </IconButton>
                                </div>
                            </Tooltip>}
                            {mode === 'list' && <Tooltip title={"Edit"}>
                                <div>
                                    <IconButton
                                        id={"edit-button"}
                                        aria-controls="edit"
                                        disabled={selectedRows.length !== 1}
                                        color="inherit"
                                        aria-label="edit"
                                        onClick={() => {
                                            setMode('edit');
                                            getFilterRefetch();
                                        }}
                                    >
                                        <EditOutlinedIcon/>
                                    </IconButton>
                                </div>
                            </Tooltip>}
                            {mode === 'list' && <Tooltip title={"Delete"}>
                                <div>
                                    <IconButton
                                        id={"delete-button"}
                                        aria-controls="delete"
                                        disabled={selectedRows.length === 0}
                                        color="inherit"
                                        aria-label="delete"
                                        onClick={() => {
                                            setMode('confirm-delete');
                                        }}
                                    >
                                        <DeleteOutlineOutlinedIcon/>
                                    </IconButton>
                                </div>
                            </Tooltip>}
                            {props.children}
                        </Toolbar>
                    </AppBar>
                </div>
                <DialogContent>
                    <div className={classes.root}>
                        {props.open && filters && mode === 'list' && (
                            <SizeMe>
                                {({size}) => {
                                    let height = size.height;
                                    if (!height) height = window.innerHeight;

                                    const tableOptions = {
                                        actionsColumnIndex: -1,
                                        header: true,
                                        // maxBodyHeight: height -100,
                                        padding: 'dense',
                                        paging: false,
                                        selection: true,
                                        selectionProps: r => ({
                                            name: r.filterName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                        }),
                                        toolbar: false,
                                    };

                                    return (<MaterialTable
                                        tableRef={tableRef}
                                        columns={columns}
                                        data={filters}
                                        icons={tableIcons}
                                        options={tableOptions}
                                        title='Filters'
                                        onSelectionChange={(rows) => {
                                            setSelectedRows(rows);
                                            if (rows.length === 1) {
                                                setSelectedObj(rows[0])
                                            } else {
                                                setSelectedObj({})
                                            }
                                        }}
                                    />);
                                }}
                            </SizeMe>
                        )}
                        {config && state && mode === 'edit' && (
                            <Grid container>
                                <Grid item xs={12}>
                                    <FormControl
                                        className={errors.filterName ? classes.formControlError : classes.formControl}
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                    >
                                        <TextField
                                            required
                                            id="filterName"
                                            name="filterName"
                                            label="Filter name"
                                            fullWidth
                                            size="small"
                                            onChange={handleFieldChange}
                                            value={filter.filterName}
                                        />
                                        <FormHelperText>
                                            {errors.filterName}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Query
                                        {...config}
                                        value={state.tree}
                                        onChange={handleQueryChange}
                                        renderBuilder={renderBuilder}
                                    />
                                    {errors.filterName}
                                </Grid>
                            </Grid>
                        )}
                        {mode === 'confirm-delete' && (
                            <Typography>Are you sure you want to delete these filter(s)?</Typography>
                        )}
                    </div>
                </DialogContent>
                <DialogActions>
                    {mode !== 'confirm-delete' && <Button
                        id={"filter-cancel"}
                        onClick={() => {
                            if (setSelectedRows.length > 0 && tableRef.current) tableRef.current.onAllSelected(false);
                            setSelectedRows([]);
                            setSelectedObj({});
                            props.handleCancel()
                        }}
                        color="primary"
                    >
                        Cancel
                    </Button>}
                    {mode === 'edit' && <Button
                        id={"filter-save"}
                        onClick={() => {
                            if (validateForm()) {
                                if (filter.filterId && filter.filterId.length > 0 && filter.filterId !== 'new') {
                                    updateFilter().then(async (updateResult) => {
                                        notify('updateFilter', 'info', 'Filter updated');
                                        setMode('list');
                                        getFiltersOfTypeRefetch();
                                    })
                                } else {
                                    createFilter().then(async (createResult) => {
                                        notify('createFilter', 'info', 'Filter created');
                                        setMode('list');
                                        getFiltersOfTypeRefetch();
                                    })
                                }
                            }
                        }}
                        color="primary"
                    >
                        Save
                    </Button>}
                    {mode === 'list' && selectedRows.length > 0 && <Button
                        id={"filter-apply"}
                        disabled={selectedRows.length !== 1}
                        onClick={() => {
                            props.handleApply(selectedObj.filterId);
                        }}
                        color="primary"
                    >
                        Apply
                    </Button>}
                    {mode === 'list' && selectedRows.length === 0 && <Button
                        id={"filter-apply"}
                        disabled={selectedRows.length > 0}
                        onClick={() => {
                            props.handleApply();
                        }}
                        color="primary"
                    >
                        No Filter
                    </Button>}
                    {mode === 'confirm-delete' && (
                        <div>
                            <Button
                                id={"filter-cancel-delete"}
                                onClick={() => {
                                    setMode('list');
                                }}
                                color="primary"
                            >
                                Cancel Delete
                            </Button>
                            <Button
                                id={"filter-confirm-delete"}
                                onClick={() => {
                                    handleDelete();
                                    getFiltersOfTypeRefetch();
                                    setMode('list');
                                }}
                                color="primary"
                            >
                                Confirm Delete
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default FilterDialog
